import React, { useState } from "react";
import toast from "react-hot-toast";
import {
  getActiveGoogTransLangCode,
  languageLabelToCode,
  waitForPageTranslation,
} from "../utils/gtranslate.js";

const LanguageSelector = ({ variant = "footer" }) => {
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    if (typeof window === "undefined") return "English (UK)";
    return localStorage.getItem("selectedLanguage") || "English (UK)";
  });

  const handleLanguageSelect = async (language) => {
    const toLangCode = languageLabelToCode(language);
    const fromLangCode = getActiveGoogTransLangCode();

    if (fromLangCode === toLangCode) {
      setSelectedLanguage(language);
      if (typeof window !== "undefined") {
        localStorage.setItem("selectedLanguage", language);
      }
      return;
    }

    const applied = await waitForPageTranslation(toLangCode);
    if (applied) {
      setSelectedLanguage(language);
      if (typeof window !== "undefined") {
        localStorage.setItem("selectedLanguage", language);
      }
    } else {
      toast.error("Translation could not start. Please try again.");
    }
  };

  const languageFlagSrc =
    selectedLanguage === "English" || selectedLanguage === "English (UK)"
      ? "/assets/images/flag/icon-flag-en.svg"
      : "/assets/images/flag/icon-flag-in.svg";

  const triggerClassName =
    variant === "footer"
      ? "btn btn-link p-0 d-flex align-items-center justify-content-center rounded-circle"
      : "nav-link";

  const triggerStyle =
    variant === "footer"
      ? {
          width: "22px",
          height: "22px",
          background: "#fff",
          textDecoration: "none",
        }
      : undefined;

  const wrapperClassName =
    variant === "footer"
      ? "dropdown d-inline-flex align-items-center"
      : "dropdown nav-icon-hover-bg rounded-circle";

  return (
    <div className={wrapperClassName}>
      <a
        className={triggerClassName}
        href="#"
        id="languageDropdownFooter"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        onClick={(e) => e.preventDefault()}
        style={triggerStyle}
        title="Language"
      >
        <img
          src={languageFlagSrc}
          alt="language"
          width="18px"
          height="18px"
          className="rounded-circle object-fit-cover"
        />
      </a>
      <div
        className="dropdown-menu dropdown-menu-end dropdown-menu-animate-up"
        aria-labelledby="languageDropdownFooter"
      >
        <div className="message-body">
          <button
            onClick={() => handleLanguageSelect("English")}
            className="d-flex align-items-center gap-2 py-3 px-4 dropdown-item w-100 border-0 bg-transparent text-start"
          >
            <div className="position-relative">
              <img
                src="/assets/images/flag/icon-flag-en.svg"
                alt="language"
                width="20px"
                height="20px"
                className="rounded-circle object-fit-cover round-20"
              />
            </div>
            <p className="mb-0 fs-3">English</p>
          </button>
          <button
            onClick={() => handleLanguageSelect("Hindi")}
            className="d-flex align-items-center gap-2 py-3 px-4 dropdown-item w-100 border-0 bg-transparent text-start"
          >
            <div className="position-relative">
              <img
                src="/assets/images/flag/icon-flag-in.svg"
                alt="India flag"
                width="20px"
                height="20px"
                className="rounded-circle object-fit-cover round-20"
              />
            </div>
            <p className="mb-0 fs-3">Hindi</p>
          </button>
          <button
            onClick={() => handleLanguageSelect("Gujarati")}
            className="d-flex align-items-center gap-2 py-3 px-4 dropdown-item w-100 border-0 bg-transparent text-start"
          >
            <div className="position-relative">
              <img
                src="/assets/images/flag/icon-flag-in.svg"
                alt="India flag"
                width="20px"
                height="20px"
                className="rounded-circle object-fit-cover round-20"
              />
            </div>
            <p className="mb-0 fs-3">Gujarati</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageSelector;
